/**
 * Initial state for the prism module.
 *
 * @module store/modules/prism/state
 */
import { PrismState } from "./types";

const state: PrismState = {
  embedType: "USE",
};

export default state;
